import React, { useEffect, useState } from "react";

// Simple live countdown hook; returns "MM:SS" or null
export function useCountdown(targetIso) {
  const [remaining, setRemaining] = useState(() => (targetIso ? Math.max(0, new Date(targetIso) - new Date()) : 0));
  useEffect(() => {
    if (!targetIso) return;
    const tick = () => setRemaining(Math.max(0, new Date(targetIso) - new Date()));
    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, [targetIso]);
  if (!targetIso) return { label: null, ms: 0 };
  const totalSec = Math.floor(remaining / 1000);
  const mm = String(Math.floor(totalSec / 60)).padStart(2, "0");
  const ss = String(totalSec % 60).padStart(2, "0");
  return { label: `${mm}:${ss}`, ms: remaining };
}
